/* KRONHERR Gastro theme JS */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const cfg = window.KG || {};
  const moneyFormat = cfg.moneyFormat || '{{amount_with_comma_separator}} €';

  const VAT = 1.19;
  const isB2B = () => document.documentElement.classList.contains('is-b2b');
  function formatMoney(cents, opts) {
    let c = Number(cents) || 0;
    if (isB2B() && !(opts && opts.gross)) c = Math.round(c / VAT);
    const value = c / 100;
    const withComma = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const noDecimals = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const plain = value.toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, plain);
  }
  function renderMoney(root) { $$('[data-cents]', root || document).forEach((el) => { el.textContent = formatMoney(el.dataset.cents); }); }
  function setMode(m) {
    document.documentElement.classList.toggle('is-b2b', m === 'b2b');
    try { localStorage.setItem('kg_mode', m); } catch (e) { /* ignore */ }
    $$('[data-mode]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mode === m)));
    renderMoney();
    document.dispatchEvent(new CustomEvent('kg:mode', { detail: m }));
  }
  window.KG = Object.assign(cfg, { formatMoney, renderMoney, setMode });
  $$('[data-mode]').forEach((b) => { b.setAttribute('aria-pressed', String(b.dataset.mode === (isB2B() ? 'b2b' : 'b2c'))); b.addEventListener('click', () => setMode(b.dataset.mode)); });
  renderMoney();

  /* ---------- header ---------- */
  const header = $('.header') || ($('.header__bar') && $('.header__bar').closest('.shopify-section'));
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll(); addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- priority nav: drop items into "Mehr" when the bar gets tight ---------- */
  const nav = $('[data-nav]');
  if (nav) {
    const items = $$('[data-nav-item]', nav); const more = $('[data-nav-more]', nav); const list = more && $('[data-nav-more-list]', more);
    const pinned = items.filter((i) => i.hasAttribute('data-nav-pin')); const flex = items.filter((i) => !i.hasAttribute('data-nav-pin'));
    if (more && pinned.length) nav.insertBefore(more, pinned[0]);
    const w = new Map();
    const layout = () => {
      if (!more || getComputedStyle(nav).display === 'none') return;
      items.forEach((i) => { i.hidden = false; }); more.hidden = false;
      items.forEach((i) => w.set(i, i.getBoundingClientRect().width)); w.set(more, more.getBoundingClientRect().width);
      const gap = parseFloat(getComputedStyle(nav).columnGap || getComputedStyle(nav).gap) || 0; const avail = nav.clientWidth;
      const sum = (arr) => arr.reduce((a, i) => a + w.get(i) + gap, 0);
      if (sum(items) - gap <= avail) { more.hidden = true; return; }
      let used = sum(pinned) + w.get(more) + gap; const overflow = []; let full = false;
      flex.forEach((i) => { if (!full && used + w.get(i) + gap <= avail) used += w.get(i) + gap; else { full = true; overflow.push(i); } });
      list.innerHTML = '';
      overflow.forEach((i) => { i.hidden = true; const src = i.matches('a') ? i : i.querySelector('a'); const a = document.createElement('a'); a.className = 'drop__link'; a.href = src.href; a.textContent = src.textContent.trim(); list.appendChild(a); });
      more.hidden = overflow.length === 0;
    };
    layout(); addEventListener('resize', layout); if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout); setTimeout(layout, 300);
  }

  /* ---------- drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false; requestAnimationFrame(() => d.classList.add('is-open'));
    document.body.classList.add('drawer-open');
    const f = d.querySelector('input, button, a'); if (f) setTimeout(() => f.focus(), 120);
  }
  function closeDrawer(d) {
    if (!d) return; d.classList.remove('is-open'); document.body.classList.remove('drawer-open');
    setTimeout(() => { d.hidden = true; }, 320);
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    const c = e.target.closest('[data-drawer-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); return; }
    if (e.target.classList.contains('drawer__overlay')) closeDrawer(e.target.closest('.drawer'));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg, kind) {
    const t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.className = 'toast' + (kind ? ' toast--' + kind : ''); t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { t.hidden = true; }, 3200);
  }

  /* ---------- cart ---------- */
  const SECTIONS = 'cart-drawer,cart-bubble';
  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const tmp = document.createElement('div'); tmp.innerHTML = sections['cart-drawer'];
      const fresh = tmp.querySelector('[data-cart-drawer-content]');
      const cur = $('#CartDrawer [data-cart-drawer-content]');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    renderMoney();
    if (sections['cart-bubble']) {
      const tmp = document.createElement('div'); tmp.innerHTML = sections['cart-bubble'];
      const fresh = tmp.querySelector('[data-cart-bubble]');
      $$('[data-cart-bubble]').forEach((b) => { if (fresh) b.replaceWith(fresh.cloneNode(true)); });
    }
  }
  async function cartAdd(items) {
    const r = await fetch(cfg.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: SECTIONS })
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'error');
    applySections(data.sections);
    return data;
  }
  async function cartChange(payload) {
    const r = await fetch(cfg.routes?.cart_change_url || '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECTIONS }, payload))
    });
    const data = await r.json(); if (!r.ok) throw new Error(data.description || 'error');
    applySections(data.sections); return data;
  }
  window.KG.cartAdd = cartAdd; window.KG.cartChange = cartChange;

  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); rm.disabled = true; try { await cartChange({ id: rm.dataset.lineRemove, quantity: 0 }); } catch (err) { toast(err.message, 'error'); } return; }
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      e.preventDefault(); const input = q.parentElement.querySelector('input'); const step = Number(q.dataset.qtyChange);
      const next = Math.max(0, (Number(input.value) || 0) + step);
      try { await cartChange({ id: input.dataset.lineKey, quantity: next }); } catch (err) { toast(err.message, 'error'); }
    }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('input[data-line-key]');
    if (input) { try { await cartChange({ id: input.dataset.lineKey, quantity: Math.max(0, Number(input.value) || 0) }); } catch (err) { toast(err.message, 'error'); } }
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* simple add-to-cart forms (cards, quick add) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-add]'); if (!form) return;
    e.preventDefault(); const btn = form.querySelector('[type="submit"]'); const id = Number(form.querySelector('[name="id"]').value);
    btn.disabled = true; btn.classList.add('is-loading');
    try { await cartAdd([{ id, quantity: Number(form.querySelector('[name="quantity"]')?.value || 1) }]); openDrawer('CartDrawer'); }
    catch (err) { toast(err.message, 'error'); } finally { btn.disabled = false; btn.classList.remove('is-loading'); }
  });

  /* ---------- configurator ---------- */
  $$('[data-configurator]').forEach(initConfigurator);
  function initConfigurator(root) {
    const dataEl = root.querySelector('script[data-config]'); if (!dataEl) return;
    let data; try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    const state = { variantId: data.selectedVariantId, care: false, accessories: new Set(), qty: 1 };
    const els = {
      price: $$('[data-price]', root), compare: $$('[data-compare-price]', root), sku: $('[data-sku]', root), avail: $('[data-availability]', root),
      total: $$('[data-total]', root), lines: $('[data-summary-lines]', root), title: $('[data-summary-title]', root),
      add: $('[data-add-to-cart]', root), addLabel: $$('[data-add-label]', root), care: $('[data-care-option]', root), stickyTotal: $$('[data-sticky-total]'), stickySub: $$('[data-sticky-sub]'),
      media: $('[data-gallery]', root)
    };
    const variantById = (id) => data.variants.find((v) => v.id === id);
    const currentVariant = () => variantById(state.variantId) || data.variants[0];

    function optionValuesToVariant() {
      const selected = $$('[data-option-index]', root).map((g) => {
        const on = g.querySelector('input:checked'); return on ? on.value : null;
      });
      return data.variants.find((v) => v.options.every((o, i) => selected[i] === null || selected[i] === o));
    }
    function updateOptionAvailability() {
      $$('[data-option-index]', root).forEach((group, gi) => {
        const selected = $$('[data-option-index]', root).map((g) => g.querySelector('input:checked')?.value ?? null);
        $$('input', group).forEach((input) => {
          const test = selected.slice(); test[gi] = input.value;
          const match = data.variants.find((v) => v.options.every((o, i) => test[i] === null || test[i] === o));
          const opt = input.closest('.opt'); opt.classList.toggle('is-unavailable', !match || !match.available);
          const p = opt.querySelector('[data-opt-price]'); if (p && match) p.textContent = match.available ? formatMoney(match.price) : data.t.sold_out;
        });
      });
    }
    function render() {
      const v = currentVariant(); if (!v) return;
      const careTier = data.care && data.care.tiers ? pickCareTier(v.price) : null;
      if (!careTier) {
        state.care = false;
        const toggle = els.care && els.care.querySelector('[data-care-toggle]');
        if (toggle) toggle.checked = false;
        if (els.care) els.care.classList.remove('is-selected');
      }
      const careOn = state.care && careTier;
      let total = v.price * state.qty + (careOn ? careTier.price : 0);
      els.price.forEach((el) => (el.textContent = formatMoney(v.price)));
      els.compare.forEach((el) => { if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = formatMoney(v.compare_at_price); el.hidden = false; } else el.hidden = true; });
      if (els.sku) els.sku.textContent = v.sku ? data.t.sku + ' ' + v.sku : '';
      if (els.avail) { els.avail.textContent = v.available ? (v.inventory_quantity > 0 && v.inventory_quantity <= 3 ? data.t.low_stock.replace('__count__', v.inventory_quantity) : (v.inventory_quantity > 0 || v.inventory_policy === 'continue' && !v.inventory_managed ? data.t.in_stock : data.t.backorder)) : data.t.sold_out; els.avail.className = 'avail' + (v.available ? '' : ' avail--out'); }
      if (els.title) els.title.textContent = data.title + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
      els.stickySub.forEach((el) => { if (v.title && v.title !== 'Default Title') el.textContent = v.title; });
      // lines
      if (els.lines) {
        let html = '';
        (data.included || []).forEach((i) => (html += `<div><b>${esc(i)}</b><span class="inc">${data.t.included}</span></div>`));
        if (careOn) html += `<div><b>${esc(data.care.title)}</b><span>${formatMoney(careTier.price)}</span></div>`;
        (data.accessories || []).forEach((a) => { if (state.accessories.has(a.id)) { total += a.price; html += `<div><b>${esc(a.title)}</b><span>${formatMoney(a.price)}</span></div>`; } });
        els.lines.innerHTML = html;
      } else { (data.accessories || []).forEach((a) => { if (state.accessories.has(a.id)) total += a.price; }); }
      els.total.forEach((el) => (el.textContent = formatMoney(total)));
      els.stickyTotal.forEach((el) => (el.textContent = formatMoney(total)));
      if (els.add) { els.add.disabled = !v.available; els.addLabel.forEach((l) => (l.textContent = v.available ? data.t.add_to_cart + ' · ' + formatMoney(total) : data.t.sold_out)); }
      if (els.care) { const p = els.care.querySelector('[data-opt-price]'); if (p) p.textContent = careTier ? '+' + formatMoney(careTier.price) : ''; els.care.hidden = !careTier; }
      // gallery: switch to variant image
      if (v.featured_media_id && els.media) { const t = els.media.querySelector(`[data-media-id="${v.featured_media_id}"]`); if (t) t.click(); }
      // url
      if (history.replaceState && data.variants.length > 1) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    function pickCareTier(price) {
      const tiers = data.care.tiers.slice().sort((a, b) => a.max - b.max);
      return tiers.find((t) => price <= t.max) || null;
    }
    root.addEventListener('change', (e) => {
      if (e.target.matches('[data-option-index] input')) { const v = optionValuesToVariant(); if (v) state.variantId = v.id; updateOptionAvailability(); }
      if (e.target.matches('[data-care-toggle]')) state.care = e.target.checked;
      if (e.target.matches('[data-accessory]')) { const id = Number(e.target.value); e.target.checked ? state.accessories.add(id) : state.accessories.delete(id); }
      if (e.target.matches('[data-qty]')) state.qty = Math.max(1, Number(e.target.value) || 1);
      $$('.opt', root).forEach((o) => { const i = o.querySelector('input'); if (i) o.classList.toggle('is-selected', i.checked); });
      render();
    });
    root.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-add-to-cart]'); if (!btn) return;
      e.preventDefault(); const v = currentVariant(); if (!v || !v.available) return;
      const items = [{ id: v.id, quantity: state.qty }];
      const careTier = data.care && data.care.tiers ? pickCareTier(v.price) : null;
      if (state.care && careTier) items.push({ id: careTier.id, quantity: 1, properties: { [data.t.care_for]: data.title + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '') } });
      state.accessories.forEach((id) => items.push({ id, quantity: 1 }));
      btn.disabled = true; btn.classList.add('is-loading');
      try { await cartAdd(items); openDrawer('CartDrawer'); toast(data.t.added); }
      catch (err) { toast(err.message || data.t.error, 'error'); }
      finally { btn.disabled = false; btn.classList.remove('is-loading'); }
    });
    document.addEventListener('kg:mode', () => { updateOptionAvailability(); render(); });
    updateOptionAvailability(); render();
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }

  /* ---------- gallery + lightbox ---------- */
  function swipe(el, cb) {
    if (!el) return; let x0 = null, y0 = null;
    el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) cb(dx < 0 ? 1 : -1); }, { passive: true });
  }
  function eager(root) {
    $$('img', root).forEach((im) => {
      im.loading = 'eager'; im.decoding = 'async'; im.setAttribute('fetchpriority', 'high');
      if (!im.complete || !im.naturalWidth) { const ss = im.getAttribute('srcset'), src = im.getAttribute('src'); if (ss) { im.removeAttribute('srcset'); im.setAttribute('srcset', ss); } if (src) { im.removeAttribute('src'); im.setAttribute('src', src); } }
    });
  }
  $$('[data-gallery]').forEach((g) => {
    const main = g.querySelector('[data-gallery-main]'); const thumbs = $$('[data-media-id]', g);
    const lb = g.querySelector('[data-lightbox]');
    const lbStage = lb && lb.querySelector('[data-lightbox-stage]'), lbThumbs = lb && lb.querySelector('[data-lightbox-thumbs]'), lbCount = lb && lb.querySelector('[data-lightbox-count]');
    let index = Math.max(0, thumbs.findIndex((t) => t.classList.contains('is-active')));
    function renderLightbox() {
      if (!lb || lb.hidden) return;
      lbStage.innerHTML = '';
      const tpl = thumbs[index] && thumbs[index].querySelector('template');
      if (tpl) lbStage.appendChild(tpl.content.cloneNode(true)); else if (main) lbStage.innerHTML = main.innerHTML;
      eager(lbStage);
      const v = lbStage.querySelector('video'); if (v) v.play().catch(() => {});
      $$('.thumb', lbThumbs).forEach((x, k) => x.classList.toggle('is-active', k === index));
      if (lbCount) lbCount.textContent = thumbs.length > 1 ? (index + 1) + ' / ' + thumbs.length : '';
    }
    function show(i) {
      if (!thumbs.length) { renderLightbox(); return; }
      index = (i + thumbs.length) % thumbs.length;
      thumbs.forEach((x, k) => x.classList.toggle('is-active', k === index));
      const tpl = thumbs[index].querySelector('template');
      if (tpl && main) { main.innerHTML = ''; main.appendChild(tpl.content.cloneNode(true)); eager(main); const v = main.querySelector('video'); if (v) v.play().catch(() => {}); }
      renderLightbox();
    }
    thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
    const prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', (e) => { e.stopPropagation(); show(index - 1); });
    if (next) next.addEventListener('click', (e) => { e.stopPropagation(); show(index + 1); });
    swipe(main, (d) => show(index + d));
    document.addEventListener('keydown', (e) => {
      const t = e.target; if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); } else if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });
    if (!lb) return;
    function openLightbox() {
      if (lbThumbs && !lbThumbs.childElementCount && thumbs.length > 1) thumbs.forEach((t, k) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'thumb'; b.setAttribute('aria-label', t.getAttribute('aria-label') || ''); const im = t.querySelector('img'); if (im) b.appendChild(im.cloneNode(true)); b.addEventListener('click', () => show(k)); lbThumbs.appendChild(b); });
      lb.hidden = false; document.body.classList.add('lightbox-open'); renderLightbox();
    }
    function closeLightbox() { lb.hidden = true; document.body.classList.remove('lightbox-open'); const v = lbStage.querySelector('video'); if (v) v.pause(); }
    if (main) main.addEventListener('click', (e) => { if (e.target.closest('video')) return; openLightbox(); });
    $$('[data-lightbox-close]', lb).forEach((b) => b.addEventListener('click', closeLightbox));
    const lp = lb.querySelector('[data-lightbox-prev]'), ln = lb.querySelector('[data-lightbox-next]');
    if (lp) lp.addEventListener('click', () => show(index - 1)); if (ln) ln.addEventListener('click', () => show(index + 1));
    swipe(lbStage, (d) => show(index + d));
    document.addEventListener('keydown', (e) => { if (!lb.hidden && e.key === 'Escape') closeLightbox(); });
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else $$('.reveal').forEach((el) => el.classList.add('is-in'));

  /* ---------- predictive search ---------- */
  const searchInput = $('[data-predictive-input]'); const searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults) {
    let t; searchInput.addEventListener('input', () => {
      clearTimeout(t); const q = searchInput.value.trim(); if (q.length < 2) { searchResults.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`${cfg.routes?.predictive_search_url || '/search/suggest'}?q=${encodeURIComponent(q)}&resources[type]=product,page&resources[limit]=6&section_id=predictive-search`);
          const html = await r.text(); const tmp = document.createElement('div'); tmp.innerHTML = html;
          const inner = tmp.querySelector('#shopify-section-predictive-search'); searchResults.innerHTML = inner ? inner.innerHTML : '';
        } catch (err) { /* ignore */ }
      }, 220);
    });
  }

  /* ---------- collection filters (client side) ---------- */
  const filterBar = $('[data-filter-bar]');
  if (filterBar) {
    filterBar.addEventListener('change', () => {
      const brands = $$('input[name="brand"]:checked', filterBar).map((i) => i.value);
      const stock = $('input[name="instock"]', filterBar)?.checked;
      let n = 0;
      $$('[data-product-card]').forEach((c) => {
        const ok = (!brands.length || brands.includes(c.dataset.vendor)) && (!stock || c.dataset.available === 'true');
        c.hidden = !ok; if (ok) n++;
      });
      const count = $('[data-results-count]'); if (count) count.textContent = count.dataset.template.replace('__count__', n);
    });
    const sort = $('[data-sort-select]'); if (sort) sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); location.href = u; });
  }

  /* ---------- sticky buy bar (top, under header) ---------- */
  const sticky = $('[data-sticky-bar]'); const buyHead = $('[data-buy-head]'); const summaryEl = $('[data-summary]');
  if (sticky && buyHead) {
    let ticking = false;
    const update = () => {
      ticking = false;
      const headBottom = buyHead.getBoundingClientRect().top + 140;
      const sumRect = summaryEl ? summaryEl.getBoundingClientRect() : null;
      const summaryVisible = sumRect && sumRect.top < window.innerHeight - 80 && sumRect.bottom > 90;
      sticky.classList.toggle('is-visible', headBottom < 0 && !summaryVisible);
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll); update();
  }
})();
